module.exports = __webpack_public_path__ + "static/media/computer-royal.369f12ff.svg";